import { ArrowRight, Building2, FileText, Package2, Phone, RefreshCcw, Rocket, Truck, Users } from "lucide-react";
import { Link } from "react-router-dom";

const FEATURES = [
  { icon: Rocket, title: "Export Shipping" },
  { icon: Package2, title: "Ecommerce Fulfilment" },
  { icon: Truck, title: "Bulk Shipments" },
  { icon: FileText, title: "Commercial Documents" },
  { icon: RefreshCcw, title: "International Returns" },
  { icon: Building2, title: "Scheduled Business Pickup" },
  { icon: Users, title: "Dedicated Account Support" },
];

export default function BusinessSection() {
  return (
    <section className="relative overflow-hidden bg-slate-50 py-20 sm:py-28" data-testid="business-section">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-saffron">Business Solutions</p>
          <h2 className="mt-3 font-heading text-3xl font-extrabold leading-tight tracking-tight text-navy sm:text-4xl lg:text-5xl">
            BUILT FOR BUSINESSES<br /><span className="text-saffron">THAT MOVE.</span>
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">
            From ecommerce sellers to exporters and growing companies, IndiaFast provides international
            shipping solutions that scale with your business.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/business-courier" data-testid="business-explore-btn"
                  className="group inline-flex items-center gap-2 rounded-full bg-navy px-7 py-3.5 text-sm font-bold text-white transition-colors hover:bg-saffron">
              Explore Business Solutions <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Link>
            <a href="tel:9783807838" data-testid="business-expert-btn"
               className="inline-flex items-center gap-2 rounded-full border-2 border-navy/15 px-7 py-3.5 text-sm font-bold text-navy transition-colors hover:border-saffron hover:text-saffron">
              <Phone className="h-4 w-4" /> Talk to a Shipping Expert
            </a>
          </div>
        </div>
        <div className="lg:col-span-7">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {FEATURES.map((f, i) => (
              <div key={f.title} data-testid={`business-feature-${i}`}
                   className="group rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-saffron/40 hover:shadow-xl">
                <span className="grid h-11 w-11 place-items-center rounded-xl bg-navy text-white transition-colors group-hover:bg-saffron">
                  <f.icon className="h-5 w-5" />
                </span>
                <p className="mt-4 font-heading text-sm font-bold text-navy">{f.title}</p>
              </div>
            ))}
            <div className="hidden items-center justify-center rounded-2xl bg-navy p-5 text-center sm:flex">
              <p className="font-heading text-sm font-bold text-white">Volume rates · GST invoicing · API booking</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
